import { Layout } from "./Layout";
import { normalizePath } from "../presenters/pagePresenter";
import { lifeShopIdFromPath, type LifeContentSnapshot } from "../models/life";
import {
  ApplicationPage,
  DirectionPage,
  EnglishJoinPage,
  EventsPage,
  FacilitiesPage,
  GettingToTaitungPage,
  GuestFeedbackPage,
  GuestHouseInfoPage,
  HomePage,
  JoinUsPage,
  LifePage,
  LifeShopPage,
  NotFoundPage,
  PrivacyPage,
  RentalPage,
  ReportPage,
  RoomsPage,
  TimetablePage,
  WorkForStayPage,
} from "./pages";

export type AppInitialData = {
  lifeContent?: LifeContentSnapshot;
};

export function App({ url, initialData }: { url: string; initialData?: AppInitialData }) {
  const path = normalizePath(url);
  const lifeShopId = lifeShopIdFromPath(path);
  let page: React.ReactNode;
  if (lifeShopId) {
    page = <LifeShopPage notionId={lifeShopId} />;
    return <Layout>{page}</Layout>;
  }
  switch (path) {
    case "/":
    case "/preview/home-image-band-video":
      page = <HomePage videoPlacement="image-band" />;
      break;
    case "/preview/home-image-band":
      page = <HomePage />;
      break;
    case "/preview/home-hero-video":
      page = <HomePage videoPlacement="hero" />;
      break;
    case "/rooms":
      page = <RoomsPage />;
      break;
    case "/events":
      page = <EventsPage />;
      break;
    case "/facilities":
      page = <FacilitiesPage />;
      break;
    case "/guest-house-info":
      page = <GuestHouseInfoPage />;
      break;
    case "/direction":
      page = <DirectionPage />;
      break;
    case "/getting-to-taitung":
      page = <GettingToTaitungPage />;
      break;
    case "/life-in-dulan":
      page = <LifePage initialPlaces={initialData?.lifeContent?.places} />;
      break;
    case "/full-property-rental":
      page = <RentalPage />;
      break;
    case "/joinus":
      page = <JoinUsPage />;
      break;
    case "/joinus-en":
      page = <EnglishJoinPage />;
      break;
    case "/application":
      page = <ApplicationPage />;
      break;
    case "/workforstay":
      page = <WorkForStayPage />;
      break;
    case "/timetable":
      page = <TimetablePage mobileTable />;
      break;
    case "/timetable-mobile":
      page = <TimetablePage />;
      break;
    case "/reportpage":
      page = <ReportPage />;
      break;
    case "/guest-feedback":
      page = <GuestFeedbackPage />;
      break;
    case "/privacy":
      page = <PrivacyPage />;
      break;
    default:
      page = <NotFoundPage />;
  }
  return <Layout>{page}</Layout>;
}
